// en
import commonEN from './en/common.json'
import planningEN from './en/planning.json'
import formsEN from './en/forms.json'
import errorEN from './en/errors.json'
import projectsEN from './en/projects.json'
import quotationsEN from './en/quotations.json'
import dataValidationEN from './en/data-validation.json'
import monitoringEN from './en/monitoring.json'
import observationLogsEN from './en/observation-logs.json'
import hoursReportingEN from './en/hours-reporting.json'
import soundRecordsEN from './en/sound-records.json'
import expensesDeclarationEN from './en/expenses-declaration.json'

//nl
import commonNL from './nl/common.json'
import planningNL from './nl/planning.json'
import formsNL from './nl/forms.json'
import errorNL from './nl/errors.json'
import projectsNL from './nl/projects.json'
import quotationsNL from './nl/quotations.json'
import dataValidationNL from './nl/data-validation.json'
import monitoringNL from './nl/monitoring.json'
import observationLogsNL from './nl/observation-logs.json'
import hoursReportingNL from './nl/hours-reporting.json'
import soundRecordsNL from './nl/sound-records.json'
import expensesDeclarationNL from './nl/expenses-declaration.json'

export const resources = {
  en: {
    common: commonEN,
    planning: planningEN,
    forms: formsEN,
    errors: errorEN,
    projects: projectsEN,
    quotations: quotationsEN,
    dataValidation: dataValidationEN,
    monitoring: monitoringEN,
    observationLogs: observationLogsEN,
    hoursReporting: hoursReportingEN,
    soundRecords: soundRecordsEN,
    expensesDeclaration: expensesDeclarationEN,
  },
  nl: {
    common: commonNL,
    planning: planningNL,
    forms: formsNL,
    errors: errorNL,
    projects: projectsNL,
    quotations: quotationsNL,
    dataValidation: dataValidationNL,
    monitoring: monitoringNL,
    observationLogs: observationLogsNL,
    hoursReporting: hoursReportingNL,
    soundRecords: soundRecordsNL,
    expensesDeclaration: expensesDeclarationNL,
  },
}
